// extracted by mini-css-extract-plugin
module.exports = {"networks":"Networks-module--networks--S1_P1","title":"Networks-module--title--jQvPB","link":"Networks-module--link--3MgqN","minimal":"Networks-module--minimal--1RSgv"};